// Generated by CoffeeScript 2.7.0
var Admin__PostsController;

import MessageCards from '../concerns/message_cards.js';

import MessageNavActions from './concerns/message_nav_actions.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

import PostForm from 'trunks/vue/admin/compositions/formables/post.js';

export default Admin__PostsController = (function() {
  class Admin__PostsController extends Skylark.App.BaseController {
    new() {
      this._initEditMessageView({
        title: '未命名消息标题',
        html_body: ''
      });
      return document.body.proxy('click', '.js_save_message', () => {
        return this._messageVm.afterValidate('publish', this._messageVm.openSaveConfirm);
      });
    }

    show() {
      this.messageType = 'post';
      return this._prepareCards();
    }

    clone() {
      this._initEditMessageView(this.getVars('post'));
      return document.body.proxy('click', '.js_save_message', () => {
        return this._messageVm.openSaveConfirm();
      });
    }

    edit() {
      this._initEditMessageView(this.getVars('post'));
      return document.body.proxy('click', '.js_save_message', () => {
        return this._messageVm.openSaveConfirm();
      });
    }

    _initEditMessageView(post) {
      this.__generateFormView(post);
      document.body.proxy('click', '.js_save_as_draft', () => {
        return this._messageVm.afterValidate('save', this._messageVm.saveAsDraft);
      });
      return document.body.proxy('click', '.js_preview', () => {
        return this._messageVm.preview();
      });
    }

    __generateFormView(post) {
      var el;
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('message_edit');
      return this._messageVm = new PostForm({
        el: el,
        data: {
          post: post
        }
      });
    }

  };

  Admin__PostsController.include(MessageCards, MessageNavActions, ToggleNavMenuAction);

  return Admin__PostsController;

}).call(this);
